import MBreadcrumb from './MBreadcrumb.vue';

MBreadcrumb.install = (app) => {
  app.component('MBreadcrumb', MBreadcrumb);
};

export { MBreadcrumb };
